import { render, staticRenderFns } from "./newreport.vue?vue&type=template&id=cef6ff1e&scoped=true&"
import script from "./newreport.vue?vue&type=script&lang=js&"
export * from "./newreport.vue?vue&type=script&lang=js&"
import style0 from "./newreport.vue?vue&type=style&index=0&id=cef6ff1e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef6ff1e",
  null
  
)

export default component.exports